import React from "react";
import { Navigate, Route } from "react-router-dom";
import { OPS_ROUTES } from "./ops/routes";
import { PHARMACY_ROUTES } from "./pharmacy/routes";
import { SALES_ROUTES } from "./sales/routes";
import { FINANCE_ROUTES } from "./finance/routes";
import { LOGISTICS_ROUTES } from "./logistics/routes";
import { INVENTORY_ROUTES } from "./inventory/routes";

// Route barrel for every v2 console. `src/navigation/routes.jsx` renders `V2_ROUTES`
// once; adding a console means adding its fragment here, not touching the app router.
//
// The consoles live at /v2/ops/*, /v2/pharmacy/*, /v2/finance/* and /v2/logistics/*. They used to share a flat /v2/*
// namespace, which stopped working once there was more than one — the redirects below
// keep the old links, bookmarks and open tabs alive rather than 404ing them.
//
// EXPORTED AS AN ARRAY, NOT A FRAGMENT. react-router's `createRoutesFromElements`
// recurses into a `<>...</>` using the *parent's* tree path, so a fragment's children
// are numbered from 0 alongside their own siblings and collide — the app dies with
// "Found a route id collision on id 0-0". An array is flattened by React.Children with
// distinct indices, so every route keeps a unique id. Keys are required for the same
// reason any list needs them.
const LEGACY_OPS_PATHS = ["overview", "orders", "quotations", "reorders", "b2b", "tat"];

export const V2_ROUTES = [
    React.cloneElement(OPS_ROUTES, { key: "ops-console" }),
    React.cloneElement(PHARMACY_ROUTES, { key: "pharmacy-console" }),
    React.cloneElement(SALES_ROUTES, { key: "sales-console" }),
    React.cloneElement(FINANCE_ROUTES, { key: "finance-console" }),
    React.cloneElement(LOGISTICS_ROUTES, { key: "logistics-console" }),
    React.cloneElement(INVENTORY_ROUTES, { key: "inventory-console" }),

    // Inventory and Procurement used to live under the pharmacist console. Redirect rather
    // than 404 -- these are bookmarked work queues, not links shared once.
    <Route key="legacy-pharmacy-inventory" path="/v2/pharmacy/inventory" element={<Navigate to="/v2/inventory/catalogue" replace />} />,
    <Route key="legacy-pharmacy-procurement" path="/v2/pharmacy/procurement/*" element={<Navigate to="/v2/inventory/procurement" replace />} />,

    // Finance used to live under the pharmacist console. Redirect rather than 404 --
    // these links were shared while the tabs were being reviewed.
    ...["orders", "quotations", "refunds", "cod"].map((tab) => (
        <Route
            key={`legacy-finance-${tab}`}
            path={`/v2/pharmacy/finance/${tab}`}
            element={<Navigate to={`/v2/finance/${tab}`} replace />}
        />
    )),

    // Old flat paths -> the ops console. `replace` so the dead URL doesn't linger in
    // history and bounce the user back through the redirect on Back.
    <Route key="v2-index" path="/v2" element={<Navigate to="/v2/ops/overview" replace />} />,
    ...LEGACY_OPS_PATHS.map((path) => (
        <Route
            key={`legacy-${path}`}
            path={`/v2/${path}`}
            element={<Navigate to={`/v2/ops/${path}`} replace />}
        />
    )),
];
